import BaseStore from "./Base.store";
import { observable } from "mobx";

export default class ConvenioStore extends BaseStore {

  @observable listaProcedimentos =[];
}
